import "babel-polyfill";
import React from 'react';
import * as Sentry from '@sentry/browser';
import ReactDOM from 'react-dom';
import {CookiesProvider} from 'react-cookie';
import App from './App.js';

Sentry.init({
  dsn: "https://1da963954e1348bda0dddfbf4aba5b6e@sentry.hostedapp.cloud/3"
});

const rootElement = <CookiesProvider><App/></CookiesProvider>;
ReactDOM.render(rootElement, document.getElementById('root'));


// WEBPACK FOOTER //
// ./src/index.js